// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { FieldsFactory } from '../Factory/FieldsFactory';
import { Message } from '@shared/utils/DirectMessages/Message';
import { PFixMessage } from './PFixMessage';
export class AcceptedMessage extends PFixMessage {
    constructor(fieldSet) {
        super(Message.CODE_PFIX_ACCEPTED_MESSAGE, fieldSet);
    }
    getOrderId() {
        return this.getFieldValue(FieldsFactory.FIELD_ORDER_ID);
    }
    setOrderId(orderId) {
        this.setFieldValue(FieldsFactory.FIELD_ORDER_ID, orderId);
    }
    getPositionId() {
        // FIELD_POSITION_ID может и не быть
        return this.getFieldValue(FieldsFactory.FIELD_POSITION_ID) || 0;
    }
    setPositionId(positionId) {
        this.setFieldValue(FieldsFactory.FIELD_POSITION_ID, positionId);
    }
}
